import { ClubPhotoTag } from '@customTypes/types';

import { useShowFullClubProfileQuery } from '@/features/work/api/show-full-club-profile';
import {
  useClubProfilePhotoListQuery,
  useClubProfileVideoListQuery
} from '@/shared/api/requests';

export const useClubConditionView = ({ clubId }: { clubId: string }) => {
  const profileInfo = useShowFullClubProfileQuery({ profileId: clubId });
  const housingPhotos = useClubProfilePhotoListQuery({
    profileId: clubId,
    tags: ClubPhotoTag.Housing
  });
  const profilePhoto = useClubProfilePhotoListQuery({
    profileId: clubId,
    tags: ClubPhotoTag.ProfilePhoto
  });
  const profileVideo = useClubProfileVideoListQuery({
    profileId: clubId
  });
  const profilePhotos = useClubProfilePhotoListQuery({
    profileId: clubId,
    tags: [
      ClubPhotoTag.HallNoGuests,
      ClubPhotoTag.HallWithGuests,
      ClubPhotoTag.PrivateRooms,
      ClubPhotoTag.Scene,
      ClubPhotoTag.WorkingHours
    ]
  });

  const queries = [profileInfo, housingPhotos, profilePhoto, profilePhotos];

  const isLoading = queries.some((q) => q.isLoading);

  return {
    state: {
      isLoading,
      profileInfo,
      profilePhoto,
      housingPhotos,
      profilePhotos,
      profileVideo
    },
    functions: {}
  };
};
